import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ReactNode } from 'react';
import type { SpaceOverviewProps } from '../src/SpaceOverview.tsx';

export const SpaceOverviewLoader: LoadableType<SpaceOverviewProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-space-overview" */ '../src/SpaceOverview.tsx'))
			.SpaceOverview,
});

export const SpaceOverviewSwitcherLoader: LoadableType<{
	spaceKey: string;
	children?: ReactNode;
	onExperienceResolved?: (experience: 'smart' | 'regular') => void;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-space-overview-switcher" */ '../src/SpaceOverviewSwitcher.tsx'
			)
		).SpaceOverviewSwitcher,
});
